import { useState } from "react";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { useAppSelector, useAppDispatch } from "hooks/store";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { setdeliveryType } from "store/slices/main.slice";
interface OrderTypePopupProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (orderType: "pickup" | "delivery") => void;
}

const OrderTypePopup: React.FC<OrderTypePopupProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const [orderType, setOrderType] = useState<"pickup" | "delivery">("pickup");
  const dispatch = useAppDispatch();
  const { settings, companyData } = useAppSelector(({ main }) => main);

  const handleSubmit = () => {
    dispatch(setdeliveryType(orderType));
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="flex items-center justify-center"
      BackdropProps={{
        onClick: (e) => e.stopPropagation(),
      }}
    >
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
        <div className="flex flex-col items-center">
          {settings?.showLogo !== 0 ? (
            <div
              onDoubleClick={() => {
                window.location.href = "/admin/setting/time";
              }}
              className="text-white !px-1.5 relative"
            >
              <img
                src={companyData?.logoUrl}
                alt=""
                className="h-16 w-16 mb-4"
              />
            </div>
          ) : (
            <div
              onDoubleClick={() => {
                window.location.href = "/admin/setting/time";
              }}
              className="text-white !px-1.5 relative"
            >
              <AdminPanelSettingsIcon className="text-white" />
            </div>
          )}

          <h1 className="text-xl font-bold text-black">
            {settings.ShowCompanyName && companyData?.companyName
              ? companyData?.companyName
              : "RANGER POS"}
          </h1>
        </div>

        <div className="flex gap-2 bg-gray-200 rounded-xl p-1 mt-4">
          <button
            className={`${
              orderType === "pickup"
                ? "bg-primary text-themeSelColor"
                : "bg-gray-200 text-gray-700"
            } py-1 px-2 transition-colors duration-300 rounded-xl flex-1`}
            onClick={() => setOrderType("pickup")}
          >
           Pickup
          </button>
          <button
            className={`${
              orderType === "delivery"
                ? "bg-primary text-themeSelColor"
                : "bg-gray-200 text-gray-700"
            } py-1 px-2 transition-colors duration-300 rounded-xl flex-1`}
            onClick={() => setOrderType("delivery")}
          >
            Delivery
          </button>
        </div>

        <Button
          onClick={handleSubmit}
          disabled={!orderType}
          variant="contained"
          className="!mt-6 w-full !bg-primary !text-themeSelColor"
        >
          Continue
        </Button>
      </div>
    </Modal>
  );
};

export default OrderTypePopup;
